/**
 * Asynchronously loads the component for CampusNotifications
 */

import { lazyLoad } from "utils/loadable";

export const CampusNotifications = lazyLoad(
  () => import("./index"),
  (module) => module.CampusNotifications
);
